import { featured } from "@/mocks/manga";

export default function Featured() {
  return (
    <section id="featured" className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
        <div>
          <p className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-sm font-medium text-primary-800">
            <i className="ri-award-fill"></i>
            霸榜作品 · 周更追踪
          </p>
          <h2 className="mt-3 font-heading text-2xl text-foreground-950 md:text-4xl">本周霸榜精选</h2>
          <p className="mt-2 text-sm text-foreground-600 md:text-base">
            连续霸榜与热度飙升之作，第一时间掌握最新话进度。
          </p>
        </div>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-6 md:grid-cols-3">
        {featured.map((w) => (
          <article
            key={w.title}
            className="group flex flex-col overflow-hidden rounded-xl bg-background-100 ring-1 ring-background-200/70"
          >
            <div className="relative h-64 w-full overflow-hidden">
              <img
                src={w.cover}
                alt={`${w.title} 霸榜作品封面`}
                className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
              />
              <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-full bg-accent-500 px-3 py-1 text-xs font-medium text-foreground-950">
                <i className="ri-flashlight-fill"></i>
                {w.tag}
              </span>
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 to-transparent p-4">
                <p className="text-sm text-background-50">{w.heat}</p>
              </div>
            </div>
            <div className="flex flex-1 flex-col p-5">
              <div className="flex items-center justify-between">
                <h3 className="font-heading text-xl text-foreground-950">{w.title}</h3>
                <span className="text-sm text-foreground-600">{w.author}</span>
              </div>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-700">{w.desc}</p>
              <div className="mt-4 flex items-center gap-3">
                <span className="inline-flex items-center gap-1 text-xs text-foreground-600">
                  <i className="ri-file-list-3-line"></i>
                  {w.chapters} 话
                </span>
                <a
                  href="#serial"
                  className="ml-auto inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-primary-500 px-3 py-1.5 text-xs font-medium text-background-50 transition-colors hover:bg-primary-600"
                >
                  开始追更
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}